
    function renderEmptyWishlist(container) {
      if (!container) return;

      let wishlist_wrap = document.querySelector(".wishlist-wrap");

      wishlist_wrap.innerHTML = `
        <div class="wishlist-empty">
          <h2>Your wishlist is empty</h2>
          <p>Looks like you haven’t added anything yet.</p>
          <a href="/collections/all" class="wishlist-shop-btn">
            Continue Shopping
          </a>
        </div>
      `;
    }

    function updateWishlistCount() {
      let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

      document.querySelectorAll(".wishlist-count").forEach(el => {

        if (wishlist.length > 0) {
          el.textContent = wishlist.length;
        } else {
          el.textContent = ""; // ✅ MUST BE EMPTY STRING
        }

      });
    }

  // ✅ INIT (product page buttons)
  function initWishlist() {

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    document.querySelectorAll(".wishlist-icon-btn").forEach(btn => {

      const handle = btn.getAttribute("data-product-handle");
      if (!handle) return;

      const emptyHeart = "https://cdn.shopify.com/s/files/1/0945/1228/3721/files/heart_79942ba9-a7e9-4d3e-a23e-8cda1dbca571.png?v=1777543349";
        const filledHeart = "https://cdn.shopify.com/s/files/1/0945/1228/3721/files/heart-fill.png?v=1777543349";
      const img = btn.querySelector("img");

     
      // Set initial state
      btn.classList.remove("active");
       img.src = wishlist.includes(handle) ? filledHeart : emptyHeart;

      // Prevent duplicate listeners
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
    });

    // Bind click
    document.querySelectorAll(".wishlist-icon-btn").forEach(btn => {

      const handle = btn.getAttribute("data-product-handle");

      btn.addEventListener("click", function (e) {
        e.preventDefault();

        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

        let index = wishlist.indexOf(handle);

        const emptyHeart = "https://cdn.shopify.com/s/files/1/0945/1228/3721/files/heart_79942ba9-a7e9-4d3e-a23e-8cda1dbca571.png?v=1777543349";
        const filledHeart = "https://cdn.shopify.com/s/files/1/0945/1228/3721/files/heart-fill.png?v=1777543349";

        if (index === -1) {
          wishlist.push(handle);
          btn.innerHTML = `<img src="${filledHeart}" class="wishlist-icon" alt="Added">`;
        } else {
          wishlist.splice(index, 1);
          btn.innerHTML = `<img src="${emptyHeart}" class="wishlist-icon" alt="Wishlist">`;
        }
        

        localStorage.setItem("wishlist", JSON.stringify(wishlist));

        // update everywhere
        document.dispatchEvent(new Event("wishlist:updated"));
      });

    });
  }

  // ✅ REMOVE BUTTON (wishlist page)
  document.addEventListener("click", function (e) {

    const btn = e.target.closest(".wishlist-remove-btn");
    if (!btn) return;

    const handle = btn.getAttribute("data-handle");
    if (!handle) return;

    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

    // Remove item
    wishlist = wishlist.filter(item => item !== handle);

    localStorage.setItem("wishlist", JSON.stringify(wishlist));

    // Remove from UI
    const item = document.querySelector(`.wishlist-item[data-handle="${handle}"]`);
    if (item) item.remove();

    // Empty state
    if (wishlist.length === 0) {
      const container = document.getElementById("wishlist-products");
      if (container) {
        renderEmptyWishlist(container);
      }
    }

    // sync UI
    document.dispatchEvent(new Event("wishlist:updated"));

  });

  // OPTIONAL: HEADER COUNT SYNC
  function updateWishlistCount() {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    document.querySelectorAll(".wishlist-count").forEach(el => {
      el.textContent = wishlist.length;
    });
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", function () {
    initWishlist();
    updateWishlistCount();
  });

  // Shopify dynamic reload support
  document.addEventListener("shopify:section:load", initWishlist);

  // Listen updates globally
  document.addEventListener("wishlist:updated", updateWishlistCount);
